import { APP } from 'src/Configs/App'
import { rtkApi } from 'src/Services/rtkApi'

export interface ManualMatchingCurator {
  userId: number
  firstName: string
  lastName: string
  playlistsCount: number
  followersCount: number
  userPhotoUrl: string
}

export interface GetManualMatchingCuratorsParams {
  campaignId: string
}

const manualMatchingCuratorsApi = rtkApi.injectEndpoints({
  endpoints: (builder) => ({
    getManualMatchingCurators: builder.query<
      ManualMatchingCurator[],
      GetManualMatchingCuratorsParams
    >({
      query: ({ campaignId }) =>
        `${APP.TIKTOK_SERVER}/artist/manual-matchings/campaign/${campaignId}/curators`,
    }),
  }),
  overrideExisting: false,
})

export const { useGetManualMatchingCuratorsQuery } = manualMatchingCuratorsApi
